<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="container py-5">
      <div class="card">
        <div class="card-body">
          <div v-if="isReady">
            <h2>{{ $t('newsLetter.hrmliIstifadi') }}</h2>
            <div v-if="status==='daily'">
              <p>
                {{ $t('newsLetter.siz') }} <strong>{{ email }}</strong> {{ $t('vasitsilSorularaGnlkAbunliyinizAktivdir') }}
              </p>

              <p>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent="setStatus('none')"
                >
                  {{ $t('newsLetter.abunliyimiDayandr') }}
                </button>
              </p>
            </div>
            <div v-else>
              <p>
                {{ $t('newsLetter.siz') }} <strong>{{ email }}</strong> {{ $t('vasitsilAbunliyinizMvcudDeyil') }}
              </p>
              <p>
                <button
                  type="button"
                  class="btn btn-success"
                  @click.prevent="setStatus('daily')"
                >
                  {{ $t('newsLetter.abunOl') }}
                </button>
              </p>
            </div>
          </div>
          <div v-else>
            <div class="alert alert-info">
              {{ $t('newsLetter.mlumatYklnir') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- login page end-->
  </div>
  <!-- latest jquery-->
</template>

<script>
import {checkNewsletterStatus, setNewsletterStatus,} from "@/repositories/GeneralDataRepository";

export default {
  name: 'NewsLetter',
  data() {
    return {
      isReady: false,
      email: '',
      status: ''
    }
  },
  mounted() {
    this.statusCheck();
  },

  methods: {
    statusCheck() {
      checkNewsletterStatus(this.$route.params['email']).then(data => {
        if (data.code === 200) {
          this.isReady = true;
          this.status = data.status;
          this.email = this.$route.params['email'];
        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("buPoctUnvan"),
            type: "warning"
          }).then(() => {
            window.location.href = "/";
          })
        } else {
          this.$swal({
            title: `Error ${data.code} !`,
            text: data.message,
            type: "error"
          }).then(() => {
            window.location.href = "/";
          })
        }
      })
    },

    setStatus(status) {
      setNewsletterStatus(this.email, status).then(data => {
        if (data.code === 200) {
          this.isReady = false;

          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("emlyytUgrlIcra"),
            type: "warning"
          })
          this.statusCheck();
        } else if (data.code === 404) {

          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("buPoctUnvan"),
            type: "warning"
          }).then(() => {
            window.location.href = "/";
          })

        } else {
          this.$swal({
            title: `Error ${data.code} !`,
            text: data.message,
            type: "error"
          }).then(() => {
            window.location.href = "/";
          })
        }
      })
    },
  }
}
</script>
